/* eslint-disable sort-imports */
// Os imports não podem ficar em ordem alfabética, por causa da prioridade de chamada deles.
import "@babel/polyfill";
import Print from "vue-print-nb";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import VueCookies  from "vue-cookies";
import * as VueGoogleMaps from "vue2-google-maps";
import crono from "vue-crono";
import { http } from "./api/index";
import App from "./App.vue";
import router from "./routers/router";
import store from "./stores/store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "animate.css";
import { OnLanguageSupportCheck } from "./services/common/auth/RouterService";
import VueGtag from "vue-gtag";

Vue.use(Print);
Vue.config.productionTip = false;
Vue.prototype.$http = http;

Vue.use(VueGoogleMaps, {
	load: {
		key:       process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
		libraries: "places",
	},
});

Vue.use(VueGtag, {
	config:   { id: process.env.VUE_APP_GA_ONEBREEZE_ID, },
	includes: [ { id: process.env.VUE_APP_GA_ONEBREEZEEURO_ID },
		{ id: process.env.VUE_APP_GA_ONEBREEZEASIA_ID },
		{ id: process.env.VUE_APP_GA_CPFL_ID },
		{ id: process.env.VUE_APP_GA_CGN_ID },
		{ id: process.env.VUE_APP_GA_ELERA_ID }
	],
}, router);

Vue.use(crono);

Vue.use(VueCookies);

Vue.use(VueTheMask);

router.beforeEach((to, from, next) =>
{
	OnLanguageSupportCheck(to, from, next);
});

new Vue({
	el:     "#app",
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App),
}).$mount("#app");
